import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import InputNumber from '../../components/Inputs/InputNumber'
import Button from '../../components/General/Button'

const EditBenefitDeduction: React.FC<any> = ({
  selectedBenefitDeduction,
  onCancel,
  onSubmit,
}) => {
  const form = useForm({
    defaultValues: {
      ...selectedBenefitDeduction,
    },
  })

  return (
    <Form
      classes="gap-x-5"
      form={form}
      onSubmit={(values) => {
        onSubmit(values)
      }}
    >
      <h2 className="col-span-12 mb-2 text-primary-900 font-bold">
        Editar beneficio
      </h2>

      <FormItem name="description" classes="xl:col-span-7">
        <InputText label="Descripción" />
      </FormItem>

      <FormItem name="amount" classes="xl:col-span-4">
        <InputNumber label="Monto" />
      </FormItem>

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              onCancel()
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button
            type="primary"
            loading={false}
            classes="w-full"
            htmlType="submit"
          >
            {'Guardar cambios'}
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default EditBenefitDeduction